import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import { ServiceScheduleDashboardComponent } from './service-schedule-dashboard.component';


const routes: Routes = [
  {
    path: '',
    component: ServiceScheduleDashboardComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ServiceScheduleDashboardRoutingModule {
}
